module.exports = __webpack_public_path__ + "static/media/AmazonJPGraphics5.542550cb.jpg";